module.exports = __webpack_public_path__ + "static/media/resourceSlides.532c4c3a.svg";